import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../../lib/store';
import {
  selectConflictExpandedConceptIds,
  selectConflictIdsInReplaceMode,
  selectConflictsAllConceptsExpanded,
} from '../../../../state/selector';
import {
  addToConflictExpandedConceptIds,
  removeFromConflictExpandedConceptIds,
  clearConflictsAllConceptsExpanded,
} from '../../../../state/supervisorSlice';

interface UseConflictConceptCardProps {
  conceptId: string;
}

interface UseConflictConceptCardResults {
  isExpanded: boolean;
  handleSetIsExpanded: (isExpanded: boolean) => void;
  conflictIdsInReplaceMode: { conflictId: string; annotationIdsToReject: string[] }[];
}
export const useConflictConceptCard = ({
  conceptId,
}: UseConflictConceptCardProps): UseConflictConceptCardResults => {
  const conflictExpandedConceptIds = useAppSelector(selectConflictExpandedConceptIds);
  const areAllConceptsExpanded = useAppSelector(selectConflictsAllConceptsExpanded);
  const isExpanded = conflictExpandedConceptIds.includes(conceptId);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (areAllConceptsExpanded === true) {
      dispatch(addToConflictExpandedConceptIds(conceptId));
    } else if (areAllConceptsExpanded === false) {
      dispatch(removeFromConflictExpandedConceptIds(conceptId));
    }
  }, [areAllConceptsExpanded, conceptId, dispatch]);

  const handleSetIsExpanded = (isExpanded: boolean) => {
    if (isExpanded) {
      dispatch(addToConflictExpandedConceptIds(conceptId));
    } else {
      dispatch(removeFromConflictExpandedConceptIds(conceptId));
    }
    dispatch(clearConflictsAllConceptsExpanded());
  };
  const conflictIdsInReplaceMode = useAppSelector(selectConflictIdsInReplaceMode);
  return {
    isExpanded,
    handleSetIsExpanded,
    conflictIdsInReplaceMode,
  };
};
